import React, { forwardRef, useContext } from 'react'
import { ProjectMenuContext } from 'contexts/ProjectContext'
import { v4 as uuidv4 } from 'uuid'
import { TranslationContext } from 'contexts/TranslationContext'

interface IProps {
  projectId: string
  rename(): void,
  remove(): void,
  copy(): void,
  exportProject(): void,
}

export const ProjectContextMenuComponent = forwardRef<HTMLDivElement, IProps>(({
  projectId, rename, remove, copy, exportProject,
}, ref) => {
  const { contextMenu } = useContext(ProjectMenuContext)
  const { t } = useContext(TranslationContext)

  const menuItems = [
    { id: uuidv4(), text: t('PROJECTS_TITLE_TEXT_RENAME'), cb: rename },
    { id: uuidv4(), text: t('PROJECTS_TITLE_TEXT_COPY'), cb: copy },
    { id: uuidv4(), text: t('PROJECTS_TITLE_TEXT_DELETE'), cb: remove },
    { id: uuidv4(), text: t('PROJECTS_TITLE_TEXT_EXPORT'), cb: exportProject },
  ]
  const isHidden = !contextMenu.visible
          || (projectId
          && (projectId !== contextMenu.projectId))
  return (
    <div
      ref={ref}
      className="project-item__context-menu context-menu"
      style={{
        position: 'absolute',
        top: contextMenu.top,
        left: contextMenu.left,
        opacity: isHidden ? 0 : 1,
        visibility: isHidden ? 'hidden' : 'visible',
      }}
    >
      {menuItems.map(menuItem => (
        <div
          key={menuItem.id}
          className="context-menu__item"
          onClick={e => {
            e.stopPropagation()
            menuItem.cb()
          }}
        >
          {menuItem.text}
        </div>
      ))}
    </div>
  )
})
